var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"basic-layout"}},[_c('keep-alive',{attrs:{"include":['userInfo', 'declare']}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }